export const FIRESTORE_CATALOGS_COLLECTION = "catalogs";